import React from "react";

import Button from '@mui/material/Button';
import API from "../../../endpoints/endpoints";
import { Controller, useForm, SubmitHandler } from "react-hook-form";
import RhfControl from "../../../rhfComponets/rhfControl";

const AddSection = (props: any) => {

    const {setModal, selectedItem, getData} = props;
    const { handleSubmit, reset, control, formState, watch, setValue: setFormValue } = useForm({
        defaultValues: selectedItem,
      });

    const handleSave = async(data: any) => {
        await API.addSection(data).then(
            setModal(false),
            getData()
            )
    }

    return(
        <div className= "w-[45%]  h-[55%] flex flex-col px-5 pb-5 bg-[white] rounded-[14px]">
            <div className="text-center mt-5"><span className="text-[#3B313F] text-2xl font-bold">{selectedItem.uuid ? "Edit":'Add'} Section</span></div>
            <form className="p-2  h-[90%] flex flex-col justify-between" onSubmit={handleSubmit(data=>handleSave(data))}>
                <div>
                    <div className="pt-6">
                        <RhfControl type="Textfeild" name="section_name" label="section name" control={control} required={true} fullWidth={true} disabled={false}/>
                    </div>

                    <div className="pt-6">
                        <RhfControl type="Textfeild" name="description" label="description" control={control} required={true} fullWidth={true} disabled={false}/>
                    </div>
                </div>

                <div className="text-center flex flex-row justify-end mt-5 ">
                        <Button className="styledButton1" variant="outlined" onClick={()=>setModal(false)} sx={{width:"100px", color:'black', border:'1px solid black',margin:"0px 2px", "&:hover": { backgroundColor: "grey", color:"white", border:'1px solid grey'}}}>Cancel</Button>
                        <Button className="styledButtonPRIMERY1" variant="outlined" type="submit" sx={{width:"100px", color:'black', border:'1px solid black',margin:"0px 2px", "&:hover": { backgroundColor: "grey", color:"white", border:'1px solid grey'}}}>{selectedItem.uuid ? "Update":'Save'}</Button>
                </div>
            </form>
        </div>
    )
}

export default AddSection;